import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initEnvironment } from './config/Config';
import store from './redux/store';
import { Provider } from 'react-redux';

initEnvironment();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  ,
  document.getElementById('root')
);